module.exports = __webpack_public_path__ + "assets/img/commercial.6177302f.svg";